import constants from "../constants/constants";

export default function Awards() {
  return (
    <div className="grid mx-auto sm:grid-cols-3 w-fit gap-x-6 gap-y-6 items-center justify-items-center mt-10">
    {constants.AWARDS.map((award, index) => (
      <div
        key={index}
        className="flex flex-col gap-y-2 text-center items-center justify-center"
      >
        <award.icon
          className="text-logo-second"
          style={{ width: 64, height: 64 }}
        />
        <span className="text-logo-second font-semibold text-lg">
          {award.year}
        </span>
        <span className="text-black font-semibold text-base">
          {award.title}
        </span>
      </div>
    ))}
  </div>
  );
}
